export default {
    data() {
        return {
            size: 10,
            current: 1,
            total: undefined,
            // params:{
            //     pageNum:1,
            //     size:10
            // }
        }
    },
    // this.params.pageNum = this.current;
    // this.params.size = this.size;
    mounted() {
        this.refresh.$on(this.$options.name + 'page', (callBack) => {
            if (typeof callBack === "function") {
                callBack.call(this)
            }
        });
    },
}
